import React from 'react';
import styled from 'styled-components';
import { ClickCollectHighscore } from './ClickCollectHighscore';
import { ClickCollectStats } from './ClickCollectStats';

const ClickCollectWrapper = styled.div`
  width: 100%;
`;

export const ClickCollect = () => {
  return (
    <ClickCollectWrapper>
      <ClickCollectStats />
      <ClickCollectHighscore />
    </ClickCollectWrapper>
  );
};
